import { UtilsService } from './../../services/utils.service';
import { LocationType } from './../../types/location.type';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
} from '@angular/core';
import { DeviceDetectorService, OS } from 'ngx-device-detector';
import { NgForOf, NgIf, NgTemplateOutlet } from '@angular/common';
import { SafeUrlPipe } from '../../modules/shared/pipes/safeUrl.pipe';
import { PipeModule } from '../../modules/shared/pipes/pipe.module';

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, NgTemplateOutlet, SafeUrlPipe, NgForOf, PipeModule],
})
export class LocationComponent implements OnChanges {
  @Input() location: LocationType;
  @Input() small = false;
  public locationParts: string[];

  public geoHref: string = '';
  public geoTarget: string = '';

  constructor(private deviceService: DeviceDetectorService) {}

  ngOnChanges(): void {
    if (this.location) {
      this.locationParts = UtilsService.getLocationDisplayName(
        this.location
      ).split(', ');

      const { lat, lng } = this.location;
      const latLng: string = [lat, lng].join(',');
      const isMobile = this.deviceService.isMobile();
      const os = this.deviceService.getDeviceInfo().os;
      const useGeo = isMobile && os !== OS.IOS;

      if (useGeo) {
        this.geoHref = `geo:${latLng}?q=${this.location.formatted_address}`;
        this.geoTarget = '_self';
      } else {
        if (isMobile && os === OS.IOS) {
          this.geoHref = `http://maps.apple.com/?ll${latLng}&q=${this.location.formatted_address}`;
          this.geoTarget = '_blank';
        } else {
          const locationQuery = this.location.is_point_on_map
            ? latLng
            : `place_id:${this.location.place_id}`;

          this.geoHref = `http://maps.google.com/maps?q=${locationQuery}`;
          this.geoTarget = '_blank';
        }
      }
    }
  }
}
